import { BaseComponent } from "react-vextensions";
import React from "react";
import { Assert } from "js-vextensions";
import { manager } from "../../index.js";
import { cssHelper } from "react-vextensions";
;
export class Icon extends BaseComponent {
    render() {
        const { divContainer, icon, iconData, size, color, style, ...rest } = this.props;
        const { css } = cssHelper(this);
        let svgComp;
        if (icon) {
            //let info = require(`../../../../../Resources/SVGs/${icon}.svg`).default;
            //let info = files[`./${icon}.svg`];
            const info = manager.iconInfo[`./${icon}.svg`];
            Assert(info != null, `Could not find icon-info for "${icon}.svg" in manager.iconInfo map. See comment in web-vcore/Source/Utils/ReactComponent/Icon.tsx for example code.`);
            svgComp = (React.createElement("svg", { ...rest, viewBox: info.viewBox, width: size, height: size, style: css(style) },
                React.createElement("use", { xlinkHref: `#${info.id}`, style: { fill: color } })));
        }
        const divContainer_final = divContainer || iconData;
        if (divContainer_final) {
            return (React.createElement("div", { ...rest, style: css({ width: size, height: size }, iconData && { background: `url(${iconData})` }, style) }, svgComp));
        }
        return svgComp;
    }
}
Icon.defaultProps = { color: "rgba(255,255,255,.7)" };
//# sourceMappingURL=Icon.js.map